export default __webpack_public_path__ + "static/media/congratulation.cfbe3a6f.svg";